var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head"},[_c('el-steps',{attrs:{"active":_vm.active,"align-center":""}},[_c('el-step',{attrs:{"title":"关联云店小程序"}}),_c('el-step',{attrs:{"title":"代开发授权添加"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }